module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Bold.513922c0.svg";